import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../data";

const Stars = ({ n }) => (
  <div className="flex gap-1" aria-label={`${n} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`h-4 w-4 ${i < n ? "fill-[#ffb000] text-[#ffb000]" : "text-neutral-700"}`} />
    ))}
  </div>
);

export const Praise = () => {
  return (
    <section id="praise" data-testid="praise" className="relative px-5 py-28 md:px-10 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between"
        >
          <div>
            <span className="font-accent text-xs uppercase tracking-[0.4em] text-[#ffb000]">The Praise</span>
            <h2 className="mt-4 font-display text-4xl font-700 uppercase leading-none chrome-text md:text-6xl">
              Wall of Praise
            </h2>
          </div>
          <div className="flex items-center gap-5 rounded-2xl border border-white/12 bg-white/[0.04] px-6 py-4 backdrop-blur-xl">
            <div className="font-display text-4xl font-700 chrome-text">5.0</div>
            <div>
              <Stars n={5} />
              <div className="mt-1 font-accent text-[11px] uppercase tracking-[0.2em] text-neutral-400">
                13+ Verified Bookings · Bristol
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`review-${i}`}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#080808] p-8 transition-colors duration-500 hover:border-white/25 md:p-10"
            >
              <Quote className="absolute right-6 top-6 h-12 w-12 text-white/[0.06]" />
              <Stars n={r.stars} />
              <p className="mt-6 font-body text-base leading-relaxed text-neutral-200 md:text-lg">"{r.text}"</p>
              <div className="mt-8 flex items-center justify-between border-t border-white/10 pt-6">
                <span className="font-accent text-sm uppercase tracking-[0.15em] text-white">{r.name}</span>
                <span className="font-body text-xs text-neutral-500">{r.car}</span>
              </div>
              {r.date && <div className="mt-2 font-body text-[11px] uppercase tracking-[0.15em] text-neutral-600">{r.date}</div>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
